<!-- FileViewerInline.vue -->
<template>
  <v-card elevation="1" rounded="md">
    <v-card-title class="text-subtitle-2 font-weight-bold d-flex align-center justify-space-between">
      <span>{{ title }}</span>
      <div class="d-flex ga-2">
        <v-btn
          v-if="signedUrl"
          :href="signedUrl"
          target="_blank"
          size="x-small"
          variant="tonal"
          prepend-icon="mdi-open-in-new"
        >Open</v-btn>
        <v-btn
          v-if="signedUrl"
          :href="signedUrl"
          target="_blank"
          size="x-small"
          prepend-icon="mdi-download"
        >Download</v-btn>
      </div>
    </v-card-title>
    <v-divider />

    <v-card-text>
      <v-alert v-if="!path" type="info" variant="tonal">Not provided.</v-alert>

      <div v-else>
        <div v-if="loading" class="d-flex justify-center py-6">
          <v-progress-circular indeterminate />
        </div>

        <!-- Image preview -->
        <v-img
          v-if="!loading && isImage && signedUrl"
          :src="signedUrl"
          :height="height"
          cover
          class="rounded"
        />

        <!-- PDF preview -->
        <div v-else-if="!loading && isPdf && signedUrl" class="file-frame rounded">
          <!-- pdf viewer; the hash params tidy the toolbar a bit -->
          <iframe
            :src="signedUrl + '#toolbar=1&navpanes=0&scrollbar=1'"
            class="w-100 h-100"
          ></iframe>
        </div>

        <!-- Unsupported preview -->
        <v-alert v-else-if="!loading && signedUrl" type="warning" variant="tonal">
          Preview not supported for this file type. You can open or download above.
        </v-alert>

        <!-- Error -->
        <v-alert v-if="error" type="error" variant="tonal" class="mt-2">
          {{ error }}
        </v-alert>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { supabase } from '@/supabaseClient'

export default {
  name: 'FileViewerInline',
  props: {
    title: { type: String, default: 'Document' },
    path: { type: String, default: '' },     // storage object key saved in DB
    bucket: { type: String, default: 'agent-documents' },
    height: { type: [Number, String], default: 420 } // preview height
  },
  data() {
    return {
      loading: false,
      error: '',
      signedUrl: ''
    }
  },
  computed: {
    isImage() {
      return /\.(png|jpe?g|gif|webp|svg)$/i.test(this.path || '')
    },
    isPdf() {
      return /\.pdf$/i.test(this.path || '')
    }
  },
  watch: {
    path: {
      immediate: true,
      async handler(v) {
        this.signedUrl = ''
        this.error = ''
        if (!v) return
        await this.createSigned()
      }
    }
  },
  methods: {
    async createSigned() {
      try {
        this.loading = true
        const { data, error } = await supabase
          .storage
          .from(this.bucket)
          .createSignedUrl(this.path, 600) // 10 minutes
        if (error) throw error
        this.signedUrl = data?.signedUrl || ''
      } catch (e) {
        this.error = e?.message || 'Could not generate a signed URL.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.file-frame {
  border: 1px solid rgba(0,0,0,.08);
  height: 420px;
  overflow: hidden;
}
</style>
